import { combineReducers } from 'redux'

import app from './app/app-reducer'
import auth from './login/auth-reducer'
import jobs from './jobs/jobs-reducer'
import pagination from './jobs/pagination-reducer'
import products from './products/products-reducer'
import locations from './locations/locations-reducer'
import users from './app/users-reducer'

export default combineReducers({
  app,
  auth,
  jobs,
  pagination,
  products,
  locations,
  users
})



// WEBPACK FOOTER //
// ./src/root-reducer.js